<template>
  <footer class="border-t-4 border-brand-600 bg-graphite-900 text-graphite-300">
    <div class="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <div class="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <img src="/Images/monteco-logo.png" alt="Monteco" class="h-[72px] w-auto" />
          <p class="mt-4 text-sm leading-relaxed text-graphite-400">
            Kompleksowa obróbka metalu dla klientów przemysłowych i biznesowych —
            od projektu CAD po malowanie i cynkowanie gotowej konstrukcji.
          </p>
        </div>

        <div>
          <h3 class="border-b border-white/10 pb-2 text-xs font-bold uppercase tracking-widest text-white">Nawigacja</h3>
          <ul class="mt-4 space-y-2.5 text-sm">
            <li><a href="#o-nas" class="transition-colors hover:text-white">O nas</a></li>
            <li><a href="#uslugi" class="transition-colors hover:text-white">Usługi</a></li>
            <li><a href="#dlaczego-my" class="transition-colors hover:text-white">Dlaczego my</a></li>
            <li><a href="#kontakt" class="transition-colors hover:text-white">Kontakt</a></li>
          </ul>
        </div>

        <div>
          <h3 class="border-b border-white/10 pb-2 text-xs font-bold uppercase tracking-widest text-white">Usługi</h3>
          <ul class="mt-4 space-y-2.5 text-sm">
            <li>Projektowanie CAD</li>
            <li>Ślusarstwo</li>
            <li>Cięcie i gięcie blach</li>
            <li>Spawanie i malowanie</li>
          </ul>
        </div>

        <div>
          <h3 class="border-b border-white/10 pb-2 text-xs font-bold uppercase tracking-widest text-white">Kontakt</h3>
          <ul class="mt-4 space-y-2.5 text-sm">
            <li>
              <a href="tel:+48616682142" class="transition-colors hover:text-white">+48 000 000 000</a>
            </li>
            <li>
              <a href="mailto:biuro@monteco.pl" class="transition-colors hover:text-white">biuro@monteco.pl</a>
            </li>
            <li class="text-graphite-400">Główna 1, 62-090 Krzyszkowo</li>
          </ul>
        </div>
      </div>

      <div class="mt-12 flex flex-col items-center justify-between gap-4 border-t border-graphite-700 pt-8 text-xs text-graphite-500 sm:flex-row">
        <p>&copy; {{ year }} MONTECO JERZYŃSKI Sp.j. Wszelkie prawa zastrzeżone.</p>
        <p>NIP: 781-193-95-71 &middot; REGON: 366273125 &middot; KRS: 0000657117</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    year() {
      return new Date().getFullYear();
    }
  }
};
</script>
